import axios from '../../utils/axios';

export const deleteTeam = async (partnerId, teamId) => {
  const response = await axios.delete(
    `/partners/${partnerId}/teams/${teamId}`
  );
  return response.data;
};
